import React from 'react';
import reframe from 'nike-re-framejs';
import { fireGAEvent } from '@/analytics';
import i18n from '@i18n';
import moment from 'moment';
import FormattedDate from './FormattedDate';
import PropTypes from 'prop-types';
import { NIKE1_MATCH, TURBO_LIVE_MATCH_DETAIL } from '@/routing/routes';
import { navigate } from '@/routing';
import { localize } from 'nike-ui/src/components/turboLive/utils';
import { sportEventLocalizedObjectUrlDescription } from 'nike-ui/src/common/sportEvents';
import { SportIconNui } from 'nike-ui/src/icons/SportIconNui';
import { getSportNameById } from 'nike-ui/src/common/utils/utils';

function LiveStreamsScoreboard({ streamId }) {
    const { subscribe } = reframe.useReframe();
    const streamEvent = subscribe(['sub::liveStreams.match', streamId]);
    if (!streamEvent) {
        return null;
    }

    const startDate = moment(streamEvent.match.startTime);
    const actualDate = moment();
    const sportId = parseInt(streamEvent.match.sportId);
    const tournamentName = localize(streamEvent.tournamentName);
    const eventId = streamEvent.match.id;
    const home = localize(streamEvent.match.home);
    const away = localize(streamEvent.match.away);
    const isPrematch = startDate > actualDate;
    const sportName = getSportNameById(sportId);
    function handleClick(event) {
        event.stopPropagation();
        fireGAEvent('Homepage', 'Prechod do detailu zapasu', 'Live prenosy');

        if (isPrematch) {
            navigate(NIKE1_MATCH, {
                eventId: eventId,
                meta: sportEventLocalizedObjectUrlDescription(streamEvent.match)
            });
        } else {
            navigate(TURBO_LIVE_MATCH_DETAIL, { sportName: sportName, matchId: eventId }, null, { tab: 'stream' });
        }
    }

    return (
        <div className="live-streams-item" data-atid="live-stream-match-goTo-detail" onClick={handleClick}>
            <div className="live-streams-header">
                <SportIconNui className="live-stream-sport-icon" sizeX="16px" sizeY="16px" sportId={String(sportId)} />
                <div className="live-stream-item-block">
                    <h2 className="live-streams-label">
                        <span className={away ? 'home' : 'home only'}>{home}</span>
                        {away ? <span className="separator">{i18n('homeAway.vs.separator')}</span> : null}
                        <span className="away">{away}</span>
                    </h2>
                    <div className="live-streams-tournament">{tournamentName}</div>
                    <div className="match-date">
                        {isPrematch ? <FormattedDate startDate={startDate} /> : <LiveMatchIndicator />}
                    </div>
                </div>
            </div>
            <div className="bell-icon">
                {/*TODO docasne (hehe) odstranujem subscribe button, pretoze treba osetrit preventDefault na onclicku a to nieje uplne trivialne*/}
                {/*{isPrematch ? <SubscribeMatchButton eventId={eventId}/> : null}*/}
            </div>
        </div>
    );
}

LiveStreamsScoreboard.propTypes = {
    streamId: PropTypes.string
};

export function LiveMatchIndicator() {
    return <span className="event-flag Live">{i18n('event.flag.live')}</span>;
}

export default LiveStreamsScoreboard;
